interface SLACategory {
  title: string;
  fill: string;
  sort?: number;
}

interface TicketSLACategory {
  title: string;
  fill: string;
  sort?: number;
  icon?: string;
}

export const SLA = {
  BROKEN_SLA: { title: "Overdue", fill: "#7F5FDC", sort: 0 },
  ALMOST_BROKEN_SLA: { title: "Due Soon", fill: "#DA5CCE", sort: 1 },
  WITHIN_SLA: { title: "On-time", fill: "#6AB7DC", sort: 2 },
  NA: { title: "No SLA", fill: "#B0B0B0FF" },
} satisfies Record<string, SLACategory>;

export const SLA_STATUS_NA = "NA";

export const DUE_DATE_STATUS = "NA";

export const TicketSlaStatus = {
  UPCOMING: "Upcoming",
  PAST_DUE: "Past Due",
  NA: "No Ticket Due Date",
  ON_TIME: "On Time",
} as const;

export type TicketSlaStatusKey = keyof typeof TicketSlaStatus;
export type TicketSlaStatusValue = (typeof TicketSlaStatus)[TicketSlaStatusKey];

export const TICKET_SLA = {
  UPCOMING: {
    title: TicketSlaStatus.UPCOMING,
    fill: "#E5E5EF",
    sort: 1,
    icon: "seem-icon-in-time",
  },
  PAST_DUE: {
    title: TicketSlaStatus.PAST_DUE,
    fill: "#BC452D",
    sort: 2,
    icon: "seem-icon-in-time",
  },
  NA: {
    title: "No Due Date",
    icon: "",
    fill: "#B0B0B0FF",
  },
  ON_TIME: {
    title: TicketSlaStatus.ON_TIME,
    fill: "#26bc8b",
    sort: 2,
    icon: "seem-icon-in-time",
  },
} satisfies Record<string, TicketSLACategory>;

export const OVERDUE_FINDINGS = "Overdue Findings";

export const slaTypes = {
  FINDING: "finding",
  TICKET: "ticket",
} as const;

export type SlaType = (typeof slaTypes)[keyof typeof slaTypes];

export type { SLACategory, TicketSLACategory };
